import React, { useState } from "react";
import { Button, Icon } from "components/Component";
import { Modal, ModalBody } from "reactstrap";
import DatePicker from "react-datepicker";

const ChatModalFilterDate = (props) => {
  const { isModalDateFilterOpen, setIsModalDateFilterOpen, setFilterDate, filterDate } = props;

  const [dateFrom, setDateFrom] = useState(filterDate?.dateFrom || null);
  const [dateTo, setDateTo] = useState(filterDate?.dateTo || null);

  const closeModal = () => {
    setIsModalDateFilterOpen(false);
    setDateFrom(filterDate?.dateFrom || null);
    setDateTo(filterDate?.dateTo || null);
  };

  const applyFilter = () => {
    setFilterDate({ dateFrom, dateTo });
    setIsModalDateFilterOpen(false);
  };

  const clearFilter = () => {
    setDateFrom(null);
    setDateTo(null);
    setFilterDate({ dateFrom: null, dateTo: null });
    setIsModalDateFilterOpen(false);
  };

  return (
    <Modal
      isOpen={isModalDateFilterOpen}
      backdrop="static"
      keyboard={false}
      toggle={closeModal}
      className="modal-dialog-centered"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="mb-4">
          <h5>Filter by Date</h5>
        </div>
        <div className="form-group mb-3">
          <label className="form-label">From</label>
          <DatePicker
            className="form-control"
            selected={dateFrom}
            onChange={(date) => setDateFrom(date)}
            selectsStart
            startDate={dateFrom}
            endDate={dateTo}
            maxDate={dateTo || undefined}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select start date"
            isClearable
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">To</label>
          <DatePicker
            className="form-control"
            selected={dateTo}
            onChange={(date) => setDateTo(date)}
            selectsEnd
            startDate={dateFrom}
            endDate={dateTo}
            minDate={dateFrom || undefined}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select end date"
            isClearable
          />
        </div>
        <div className="d-flex justify-content-around mt-3">
          <Button color="light" onClick={clearFilter} className="col-5" style={{ justifyContent: "center" }}>
            Clear
          </Button>
          <Button
            color="primary"
            onClick={applyFilter}
            className="col-5"
            style={{ justifyContent: "center" }}
          >
            Apply Filter
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ChatModalFilterDate;
